import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useConfig } from "./contexts/ConfigContext";

function RequireFeature({
  featureKey,
  redirectTo = "/error?reason=feature-disabled",
}) {
  const location = useLocation();
  const config = useConfig();
  const enabled = Boolean(config?.features?.[featureKey]);

  if (!enabled) {
    return (
      <Navigate
        to={redirectTo}
        replace
        state={{ from: location, reason: "feature-disabled", featureKey }}
      />
    );
  }

  return <Outlet />;
}

export default RequireFeature;

